import React, {useEffect, useState} from 'react';
import {Carousel, Layout} from 'antd';
import Sidebar from "../../navBars/Sidebar";
import Headerbar from "../../navBars/Headerbar";
import {Card, Dropdown, Spacer, Text} from "@nextui-org/react";
import {MDBCol, MDBIcon, MDBRow} from "mdbreact";
import TopSellingProducts from "./Charts/TopSellingProducts";
import  SystemUsersPieChart  from './Charts/SystemUsersPieChart';
import {getFirestore, collection} from "firebase/firestore";
import Firebase from "../../Firebase/Firebase";
import {useNavigate} from "react-router-dom";
import {useCollection} from "react-firebase-hooks/firestore";
import TopSellers from "./Charts/TopSellers";
import TopViewedProducts from "./Charts/TopViewedProducts";
import TopViewedSellers from "./Charts/TopViewedSellers";
import LiveActivity from "./LiveActivity";
import {doc, query, updateDoc, where} from "firebase/firestore";
var db = getFirestore(Firebase);
const { Content } = Layout;
function Home () {

    const [collapsed, setCollapsed] = useState(false);
    const navigate = useNavigate();

    const [sellerSnapshot] = useCollection(query(collection(db, 'users'), where("type", "==", `Seller`)),
    {
        snapshotListenOptions: { includeMetadataChanges: true },
    }
);
    const [sellerSnapshot1] = useCollection(collection(db, 'sellers'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [transSnapshot] = useCollection(collection(db, 'orders'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [buyerSnapshot] = useCollection(collection(db, 'users'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [productSnapshot] = useCollection(collection(db, 'products'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [bannerSnapshot] = useCollection(collection(db, 'banners'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [logSnapshot] = useCollection(collection(db, 'logs'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    const [pendingPayoutsSnapshot] = useCollection(collection(db, 'pendingPayouts'),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );
    const [sellerDebtsSnapshot] = useCollection(collection(db, 'sellerDebts'),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );
    const [productStatsSnapshot] = useCollection(collection(db, 'productStats'),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );
    const [sellerStatsSnapshot] = useCollection(collection(db, 'sellerStats'),
        { snapshotListenOptions: { includeMetadataChanges: true } }
    );
    const [logsArray, setLogsArray] = useState<any[]>([]);
    const [bannerArray, setBannerArray] = useState<any[]>([]);
    const [sellingProducts, setSellingProducts] = useState<any[]>([]);
    const [topSellers, setTopSellers] = useState<any[]>([]);
    const [sellerArray, setSellerArray] = useState<any[]>([]);
    const [productArray, setProductArray] = useState<any[]>([]);
    const [userArray, setUserArray] = useState<any[]>([]);
    const [transArray, setTransArray] = useState<any[]>([]);
    const [topToggle1, setToggle1] = useState<number>(5);
    const [topToggle2, setToggle2] = useState<number>(5);

    const list = [
        {
            title: "Sellers",
            url: "/shops",
            icon:<MDBIcon icon={'shopping-cart'} style={{color: "#29327b"}} size="2x" className="mb-2"/>,
            price: userArray.filter(x => x.type === "Seller").length,

        },
        {
            title: "Transactions",
            url: "/transactions",
            icon:<MDBIcon icon={'money-bill-alt'} style={{color: "#29327b"}} size="2x" className="mb-2"/>,
            price: transArray.length,
        },
        {
            title: "Buyers",
            url: "/buyers",
            icon:<MDBIcon icon={'users'} size="2x" style={{color: "#29327b"}} className="mb-2"/>,
            price: userArray.filter(x => x.type === "buyer").length,
        },
        {
            title: "Products",
            url: "/products",
            icon:<MDBIcon icon={'shopping-bag'} style={{color: "#29327b"}} size="2x" className="mb-2"/>,
            price: productArray.length,
        }
    ];

    function onlyUnique(value: any, index: any, self: string | any[]) {
        return self.indexOf(value) === index;
    }

    function fmt(n: number) {
        return 'MK ' + n.toLocaleString('en-US', {maximumFractionDigits: 0});
    }

    // Only banners that are actually serving: active and not past their end date.
    const liveBanners = bannerArray.filter(b => {
        if (b.isActive === false) return false;
        const end = b.endDate?.toDate ? b.endDate.toDate() : null;
        return end ? end.getTime() > Date.now() : true;
    });

    const completedOrders  = transArray.filter(o => o.orderStatus === 'completed' || o.orderStatus === 'delivered');
    const pendingOrders    = transArray.filter(o => o.orderStatus === 'pending');
    const cancelledOrders  = transArray.filter(o => o.orderStatus === 'cancelled');
    const totalRevenue     = completedOrders.reduce((s, o) => s + (Number(o.totalAmount) || 0), 0);
    const avgOrderValue    = completedOrders.length ? totalRevenue / completedOrders.length : 0;

    // Real behavioural stats (interaction-events pipeline) — empty until data accrues.
    const productStatsArray = (productStatsSnapshot?.docs ?? []).map(d => ({ ...d.data(), id: d.id }));
    const sellerStatsArray  = (sellerStatsSnapshot?.docs ?? []).map(d => ({ ...d.data(), id: d.id }));

    const pendingPayoutsData = (pendingPayoutsSnapshot?.docs ?? []).map(d => d.data());
    const pendingPayoutsTotal = pendingPayoutsData.reduce((s, p) => s + (Number(p.amount) || 0), 0);
    const pendingPayoutsCount = pendingPayoutsData.length;

    const sellerDebtsTotal = (sellerDebtsSnapshot?.docs ?? [])
        .map(d => d.data())
        .reduce((s, d) => s + (Number(d.amount) || 0), 0);

    const financialStats = [
        {
            title: 'Total Revenue',
            value: fmt(totalRevenue),
            sub:   `${completedOrders.length} completed orders`,
            icon:  <MDBIcon icon="chart-line"  size="2x" style={{color:'#059669'}} className="mb-2"/>,
            color: '#059669', bg: '#f0fdf4',
        },
        {
            title: 'Avg Order Value',
            value: fmt(avgOrderValue),
            sub:   'per completed order',
            icon:  <MDBIcon icon="receipt"     size="2x" style={{color:'#0284c7'}} className="mb-2"/>,
            color: '#0284c7', bg: '#f0f9ff',
        },
        {
            title: 'Pending Orders',
            value: String(pendingOrders.length),
            sub:   'awaiting confirmation',
            icon:  <MDBIcon icon="clock"       size="2x" style={{color:'#d97706'}} className="mb-2"/>,
            color: '#d97706', bg: '#fffbeb',
            url:   '/transactions',
        },
        {
            title: 'Cancelled Orders',
            value: String(cancelledOrders.length),
            sub:   'total cancellations',
            icon:  <MDBIcon icon="times-circle" size="2x" style={{color:'#dc2626'}} className="mb-2"/>,
            color: '#dc2626', bg: '#fef2f2',
        },
        {
            title: 'Pending Payouts',
            value: fmt(pendingPayoutsTotal),
            sub:   `${pendingPayoutsCount} seller payout${pendingPayoutsCount !== 1 ? 's' : ''} queued`,
            icon:  <MDBIcon icon="money-check" size="2x" style={{color:'#7c3aed'}} className="mb-2"/>,
            color: '#7c3aed', bg: '#faf5ff',
        },
        {
            title: 'Seller Debts',
            value: fmt(sellerDebtsTotal),
            sub:   'owed to platform (cancellations)',
            icon:  <MDBIcon icon="balance-scale" size="2x" style={{color:'#be185d'}} className="mb-2"/>,
            color: '#be185d', bg: '#fdf2f8',
        },
    ];

    useEffect(() => {
        var logs: any[] = [];
        if(logSnapshot){
            logSnapshot.docs.map((doc: { data: () => any; }) => {
                logs.push(doc.data());
            });
            setLogsArray([...logs]);
        }

        var sellers: any[] = [];
        sellerSnapshot?.docs.map((doc: { data: () => any; }) => {
            sellers.push(doc.data());
        });
        setSellerArray(sellers);

        var buyers: any[] = [];
        buyerSnapshot?.docs.map((doc: { data: () => any; }) => {
            buyers.push(doc.data());
        });
        setUserArray(buyers);

        var products: any[] = [];
        productSnapshot?.docs.map((doc: { data: () => any; }) => {
            products.push(doc.data());
        });
        setProductArray(products);

        var transactions: any[] = [];
        transSnapshot?.docs.map((doc: { data: () => any; }) => {
            transactions.push(doc.data());
        });
        setTransArray(transactions);

        var banArray: any[] = [];
        bannerSnapshot?.docs.map((doc: { id: string; data: () => any; }) => {
            banArray.push({...doc.data(), id: doc.id});
        });
        setBannerArray([...banArray]);

    
        var tempArray2: any[] = [];
        sellers.map((seller) => {
            var sellerOrders = transactions.filter(x => x.sellerId === seller.Uid);
            //var result = sellerOrders.reduce(function (acc, obj) { return acc + parseInt(obj.quantity); }, 0);

            tempArray2.push(
                {
                    sellerId: seller.Uid,
                    seller: <a>{seller.fullName}</a>,
                    orders: sellerOrders.length,
                    sold: sellerOrders.filter(x => (x.orderStatus === "delivered" || x.orderStatus === "completed")).length
                }
            )
        });
        setTopSellers([...tempArray2]);

        var tempArray: any[] = [];
        products.map((product) => {
            var prodOrders = transactions.filter(x => x.items[0].productId == product.productId);
            var result = prodOrders.reduce(function ( acc, obj) {return parseInt(  acc + obj.quantity); },  0);

            var peopleArray: string[] = [];
            prodOrders.forEach((obj) => { peopleArray.push(obj.buyerId) });

            peopleArray = peopleArray.filter(onlyUnique);

            tempArray.push(
                {
                    productId: product.productId,
                    name: product.name,
                    seller: sellers.find(x => (x.Uid) === product.sellerId)?.fullName,
                    units:    prodOrders.length,
                    //    units: result,
                    buyers : peopleArray.length
                }
            );
        });

        tempArray = tempArray.filter(x => x.units !== 0);
        setSellingProducts([...tempArray]);



    }, [transSnapshot, sellerSnapshot, buyerSnapshot, productSnapshot, bannerSnapshot, logSnapshot,]);



    return (
        <Layout style={{ minHeight: '100vh' }}>

            <Headerbar collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout className="site-layout">
                <Sidebar collapsed={collapsed}/>
                <Content>

                    <div className="mt-3 mx-3">

                        {/* ── Financial Overview ─────────────────────────── */}
                        <MDBRow className="mb-2">
                            {financialStats.map(stat => (
                                <MDBCol key={stat.title} md="2" style={{paddingLeft:6, paddingRight:6}}>
                                    <div onClick={() => stat.url && navigate(stat.url)}
                                         style={{
                                             background: stat.bg,
                                             border: `1px solid ${stat.color}22`,
                                             borderLeft: `4px solid ${stat.color}`,
                                             borderRadius: 12,
                                             padding: '12px 14px',
                                             marginBottom: 8,
                                             cursor: stat.url ? 'pointer' : 'default',
                                         }}>
                                        {stat.icon}
                                        <div style={{fontSize: 11, color: '#888', fontWeight: 500}}>{stat.title}</div>
                                        <div style={{fontSize: 17, fontWeight: 800, color: stat.color, marginTop: 2}}>
                                            {stat.value}
                                        </div>
                                        <div style={{fontSize: 10, color: '#aaa', marginTop: 2}}>{stat.sub}</div>
                                    </div>
                                </MDBCol>
                            ))}
                        </MDBRow>

                        {/* ── Live activity + leaderboard ──────────────── */}
                        <LiveActivity/>

                        <MDBRow>
                            <MDBCol md="5">
                                <MDBRow>
                                    {list.map((item) => (
                                        <MDBCol key={item.title}>
                                            <div className="stat-card my-1"
                                                 style={{cursor:'pointer'}}
                                                 onClick={() => navigate(item.url)}>
                                                <div className="stat-icon">{item.icon}</div>
                                                <div className="stat-label">{item.title}</div>
                                                <div className="stat-value">{item.price}</div>
                                            </div>
                                        </MDBCol>
                                    ))}
                                </MDBRow>
                                <Spacer y={0.3}/>
                                <Card className="my-2 font-JosefinSans overflow-hidden">
                                    <Card.Header>
                                        <Text b h5 size={17} className="m-2">System Users</Text>
                                    </Card.Header>
                                    <Card.Body>
                                        <SystemUsersPieChart
                                            sellers={userArray.filter(x => x.type === "Seller").length}
                                            buyers={userArray.filter(x => x.type === "buyer").length}
                                            admins={userArray.filter(x => x.userRole === "Admin").length}/>
                                    </Card.Body>
                                </Card>
                                <Card className="my-2 font-JosefinSans overflow-hidden">
                                    <Card.Header>
                                        <Text b h5 size={17} className="m-2">Top Sellers</Text>
                                    </Card.Header>
                                    <Card.Body>
                                        <TopSellers data={topSellers}/>
                                    </Card.Body>
                                </Card>

                                <Card className="my-2 font-JosefinSans overflow-hidden">
                                    <>

                                        <div className="d-flex flex-row w-100 justify-content-between pt-3 px-3">
                                            <Text b h5 size={17} className="m-2">Top Viewed Sellers</Text>

                                            <Dropdown>
                                                <Dropdown.Button flat>Change</Dropdown.Button>
                                                <Dropdown.Menu aria-label="Dynamic Actions"
                                                               onAction={(key) => {
                                                                   setToggle1(parseInt(key.toString()));
                                                               }}
                                                               items={[
                                                    { key: 5, name: "Top 5" },
                                                    { key: 10, name: "Top 10" },
                                                    { key: 15, name: "Top 15" },
                                                ]}>
                                                    {(item:any) => (
                                                        <Dropdown.Item
                                                            key={item.key}

                                                        >
                                                            {item.name}
                                                        </Dropdown.Item>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                    </>
                                    <Card.Body>
                                        <TopViewedSellers stats={sellerStatsArray} sellers={sellerArray} toggleNumber={topToggle1}/>
                                    </Card.Body>
                                </Card>

                            </MDBCol>
                            <MDBCol md="7">
                                <Card className="my-2 font-JosefinSans" isHoverable isPressable
                                      style={{ overflow: 'hidden'}}
                                      onPress={() => {
                                          navigate("/promotions");
                                      }}>
                                    <Card.Header css={{ position: "absolute", zIndex: 1, top: 5 }}>
                                        <Text b h5 size={17} className="m-2">Live Banners</Text>
                                    </Card.Header>
                                    {liveBanners.length > 0 ? (
                                        <Carousel autoplay>
                                            {liveBanners.map((item) => (
                                                <div key={item.id}>
                                                    <Card css={{ bg: "$white", w: "100%" }}>
                                                        <Card.Image
                                                            src={item?.imageUrl}
                                                            width="100%"
                                                            height={260}
                                                            objectFit="cover"
                                                            alt={item.id}
                                                        />
                                                    </Card>
                                                </div>
                                            ))}
                                        </Carousel>
                                    ) : (
                                        <div style={{height:260, display:'flex', alignItems:'center',
                                                     justifyContent:'center', color:'#aaa', fontSize:14}}>
                                            No live banners running
                                        </div>
                                    )}
                                </Card>
                                <Card className="my-2 font-JosefinSans overflow-hidden">
                                    <Card.Header>
                                        <Text b h5 size={17} className="m-2">Top Selling Products</Text>
                                    </Card.Header>
                                    <Card.Body>
                                  <TopSellingProducts data={sellingProducts}/>
                                    </Card.Body>
                                </Card>
                                <Card className="my-2 font-JosefinSans overflow-hidden">
                                    <>

                                        <div className="d-flex flex-row w-100 justify-content-between pt-3 px-3">
                                            <Text b h5 size={17} className="m-2">Top Viewed Products</Text>

                                            <Dropdown>
                                                <Dropdown.Button flat>Change</Dropdown.Button>
                                                <Dropdown.Menu aria-label="Dynamic Actions"
                                                               onAction={(key) => {
                                                                   setToggle2(parseInt(key.toString()));
                                                               }}
                                                               items={[
                                                                   { key: 5, name: "Top 5" },
                                                                   { key: 10, name: "Top 10" },
                                                                   { key: 15, name: "Top 15" },
                                                               ]}>
                                                    {(item:any) => (
                                                        <Dropdown.Item
                                                            key={item.key}

                                                        >
                                                            {item.name}
                                                        </Dropdown.Item>
                                                    )}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                    </>
                                    <Card.Body>
                                        <TopViewedProducts stats={productStatsArray} products={productArray} toggleNumber={topToggle2}/>
                                    </Card.Body>
                                </Card>
                            </MDBCol>
                        </MDBRow>
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
}

export default Home;
